import { ComponentChildren, h } from 'preact'
import classNames from 'classnames'

interface Props {
    children?: ComponentChildren,
    collapsible: boolean,
    isOpen: boolean,
    customClass?: string,
}

const PanelBody = ({ children, collapsible, isOpen, customClass = '' } : Props) => (
  <div class={classNames({
    'panel-body': true,
    'panel-body--collapsible': collapsible,
    'panel-body--collapse': !isOpen,
    'panel-body--expand': isOpen },
  customClass
  )}>
    {children}
  </div>
)

export default PanelBody
